// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"818":"3b53517f","5479":"3b53517f","6716":"6a94c759","8053":"3b53517f","9000":"3b53517f","9762":"3b53517f"}[chunkId] + ".chunk.css";
};